import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import { SERVER_URL } from '../constants';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import dayjs from 'dayjs';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';
import { formatDate } from '../helpers/Helpers';
import { formatTime } from '../helpers/Helpers';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));
  
  
function FixedScheduleTimeSlotPicker (props) {

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const [message, setMessage] = useState("");

    useEffect(() => {
        if (open || props.openTimePicker) {
            setMessage("fetching data...");
            setTimeSlots([]);
            fetchAvailableTimeSlots();
            setId("");
            setTime("");
        }
    }, [open, props.openTimePicker]); // runs whenever open state changes

    const [timeSlots, setTimeSlots] = useState([]);

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false)
            props.setOpenTimePicker(false);
        }
    };   

    const [type, setType] = React.useState(1);

    const [id, setId] = useState("");
    const [time, setTime] = useState("");

    const handleChange = (event) => {
        setType(event.target.value);
        // console.log("event.target", event.target);
        const [id, time] = event.target.value.split("|");
        setId(id);
        setTime(time);
        // props.setSelectedTimeSlotId(id);
        // props.setSelectedTime(time);
    };

    const handleSelect = () => {
        console.log("handleSelect");
        props.setSelectedTimeSlotId(id);
        props.setSelectedTime(time);
        handleClose();
        props.handleClose();
    };

    const fetchAvailableTimeSlots = () => {
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/cust/list-available-timeslots/' + props.scheduleId, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            console.log("fetchAvailableTimeSlots data.data", data.data);
            setTimeSlots(data.data);

            if (data.data.length > 0) {
                
            } else {
                if (data.data.length < 1) setMessage("No available timeslots");
            }
        })
        .catch(err => console.error(err));
    }


    return(
        <React.Fragment>
            <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open || props.openTimePicker}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    spacing={0}
                    >
                        <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                        Pick Preferred Timeslot
                        </Typography>
                        <Typography variant="body1">
                        {props.officeName}<br />{formatDate(props.selectedDate)}
                        </Typography>
                    </Stack>
                </DialogTitle>
            
                <DialogContent sx={{ m: 0, p: 0 }} dividers>
                    {timeSlots.length > 0 ?
                    <FormControl>
                        <RadioGroup name="type" onChange={handleChange}>
                        {timeSlots.map(timeSlot => (
                            <FormControlLabel
                            key={timeSlot.id}
                            value={`${timeSlot.id}|${formatTime(timeSlot.time)}`}
                            control={<Radio />}
                            sx={{ mb: 0 }} // adds spacing below this option
                            label={
                                <Box display="flex" flexDirection="column">
                                <Typography variant="body1" fontWeight="bold">
                                    {formatTime(timeSlot.time)}
                                </Typography>
                                </Box>
                            }
                            />
                        ))} 
                        </RadioGroup>
                    </FormControl>
                    : null }
                    {timeSlots.length < 1 ? <Typography  sx={{ ml: 2, flex: 1 }} variant="body2" component="div">{ message }</Typography> : null}
                </DialogContent>
                <DialogActions>
                    {timeSlots.length > 0 ?
                    <Button 
                        onClick={handleSelect}
                        disabled={!id}
                    >
                        Select
                    </Button>
                    : null}
                    <Button autoFocus onClick={handleClose}>
                        {timeSlots.length < 1 ?  "Ok" : "Cancel"}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default FixedScheduleTimeSlotPicker;